import { useFlagValue } from '@labrav/flags'
import { useUserType } from '@labrav/common'
import type { ActiveProducts } from '@labrav/common'

import { useSelector } from '../../../store'
import { PartnerType } from '../../../types/external'
import type {
  MarketplaceMultipleApnAccess,
  MarketplaceMultipleApnSubscribedProducts,
} from './MarketplaceMultipleApn.types'
import { getIsFlyoutSubscribed } from './MarketplaceMultipleApn.utils'

export const useMarketplaceMultipleApnAccess =
  (): MarketplaceMultipleApnAccess => {
    const partnerInviteEnabled = useFlagValue('partnerInvite')
    const userType = useUserType()
    const subscribedProducts = useSelector(
      state =>
        state.AccountData?.[userType as PartnerType]?.partnerData
          ?.subscribedProducts as
          | MarketplaceMultipleApnSubscribedProducts
          | undefined
    )
    const flyoutProduct = subscribedProducts?.FLYOUT
    const isFlyoutSubscribed = getIsFlyoutSubscribed({
      partnerInviteEnabled: partnerInviteEnabled?.value,
      flyoutProduct,
    })
    const flyoutSellerInfo = useSelector(state => state.flyoutSellerInfo)
    const isFlyoutOnboarded = flyoutSellerInfo?.onboarded === true
    const activeProducts = useSelector(
      state =>
        (state.AccountData.user.partnerData?.activeProducts as
          | ActiveProducts
          | undefined) || []
    )

    return {
      isFlyoutSubscribed,
      isFlyoutOnboarded,
      activeProducts,
    }
  }
